import React from 'react';
import { Modal } from '@veneer/core';
import '../../../assets/css/views/activations/activationsAssignation.css';

interface ModalScreenProps {
    show: boolean;
    title: string;
    footer?: React.ReactNode;
    children?: React.ReactNode;
    onClose?: () => void;
}

const ModalScreen: React.FC<ModalScreenProps> = ({ show, title, footer, children, onClose }) => {
    return (
        <div>
            <Modal
                align="start"
                id="modal-Mass"
                show={show}
                footer={footer}
                title={''}
                onClose={onClose}
            >
                <div className="custom-modal-header">
                    <h2>{title}</h2>
                    <button className="close-btn" onClick={onClose}>
                        &times;
                    </button>
                </div>
                {children}
            </Modal>
        </div>
    );
};

export default ModalScreen;
